import {
  IconButton,
  Tooltip,
  type IconButtonProps,
  type TooltipProps,
} from '@chakra-ui/react'
import { FiDatabase, FiRefreshCw } from 'react-icons/fi'

type RefreshIconButtonProps = Omit<
  IconButtonProps,
  'aria-label' | 'icon' | 'variant' | 'bg' | '_hover' | '_active'
> & {
  label: string
  icon?: IconButtonProps['icon']
  tooltipPlacement?: TooltipProps['placement']
}

export function RefreshIconButton({
  icon,
  label,
  tooltipPlacement = 'top',
  size = 'sm',
  ...buttonProps
}: RefreshIconButtonProps) {
  return (
    <Tooltip
      label={label}
      placement={tooltipPlacement}
      hasArrow
      shouldWrapChildren
    >
      <IconButton
        {...buttonProps}
        aria-label={label}
        icon={icon ?? <FiRefreshCw />}
        size={size}
        variant="ghost"
        bg="transparent"
        _hover={{ bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        _focusVisible={{ bg: 'transparent', boxShadow: 'outline' }}
      />
    </Tooltip>
  )
}

export function CacheRefreshIconButton(props: RefreshIconButtonProps) {
  return <RefreshIconButton {...props} icon={<FiDatabase />} />
}
